import { ArrowBackIos } from '@mui/icons-material';
import { FC, useMemo, useState } from 'react';
import { updateInvoiceItemFreeDays } from 'services';
import { InvoiceItem } from 'types';
import { EditAction } from './enums';

type EditFreeDaysProps = {
  invoiceItem: InvoiceItem;
  setSelectedAction: (action: EditAction | null) => void;
  close: () => void;
  onItemEditSuccess: () => void;
};

export const EditFreeDays: FC<EditFreeDaysProps> = ({ invoiceItem, setSelectedAction, close, onItemEditSuccess }) => {
  const [freeDays, setFreeDays] = useState(invoiceItem.freeDays);
  const [freeDaysInputValid, setFreeDaysInputValid] = useState(true);

  const daysInBillingPeriod = useMemo<number>(
    () => invoiceItem.freeDays + invoiceItem.chargedDays,
    [invoiceItem.chargedDays, invoiceItem.freeDays]
  );

  return (
    <form noValidate onSubmit={e => e.preventDefault()}>
      <div className="grid-2" style={{ gridTemplateColumns: '1fr 2fr' }}>
        <div>
          <label>Charged Days</label>
          <p className="text-big pt-2">{daysInBillingPeriod - freeDays}</p>
        </div>
        <div className="d-flex flex-column">
          <label>Free Days</label>
          <input
            type="number"
            value={freeDays}
            onChange={e => {
              setFreeDays(Number(e.target.value));
              setFreeDaysInputValid(e.target.checkValidity());
            }}
            min={0}
            max={daysInBillingPeriod}
          />
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-between mt-3">
        <div>
          <button className="btn-back" onClick={() => setSelectedAction(null)}>
            <ArrowBackIos fontSize="small" />
            Back
          </button>
        </div>
        <div className="d-flex g-2">
          <button type="button" className="btn-outline" onClick={() => close()}>
            Cancel
          </button>
          <button
            type="submit"
            className="btn-primary"
            disabled={!freeDaysInputValid}
            onClick={() => {
              updateInvoiceItemFreeDays({ invoiceItemId: invoiceItem.id, freeDays }).then(() => {
                close();
                onItemEditSuccess();
              });
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};
